//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { STATUS, getConfig } from './const'

import Start from './_start'

let SHARE_TEXT
let SHARE_IMG

export default {
    data () {
        return {
            status: STATUS.START,
            title: '',
            sub_title: '',
            question_list: [],
            need_btn_main_tx: '',
            need_btn_sub_tx: ''
        }
    },
    computed: {
        page_title () {
            return '资格查询'
        }
    },
    created () {
        getConfig().then(({ share_img, share_text, title, sub_title, question_list, need_btn_main_tx, need_btn_sub_tx }) => {
            SHARE_TEXT = share_text
            SHARE_IMG = share_img
            this.title = title
            this.sub_title = sub_title
            this.question_list = question_list
            this.need_btn_main_tx = need_btn_main_tx
            this.need_btn_sub_tx = need_btn_sub_tx
        })
    },
    methods: {
        openList(index) {
            this.question_list[index].open = !this.question_list[index].open
        },
        changeType (verify_type) {
            this.$router.push({
                name: 'check_condition_verify',
                params: {
                    verify_type,
                    now: Date.now()
                }
            })
        }
    },
    components: {
        Start
    }
}
